





























import Vue from 'vue'
import Component from 'vue-class-component';
import trip from '@/store/modules/trip';
import { find } from 'linkifyjs';
//@ts-ignore
import LinkPrevue from 'link-prevue';
import { Prop } from 'vue-property-decorator';

@Component({
    components: {
        LinkPrevue
    }
})
export default class WriteMessage extends Vue {

  message: string = "";
  replyTo: string = "";
  
  async closeModal() {
    this.message = "";  
    await this.$ionic.modalController.dismiss();
  }

  async sendMessage() {
    await trip.sendFeedMessage({ message: this.message, replyTo: this.replyTo });
    this.message = "";
    await this.$ionic.modalController.dismiss();
  }
  
  public get url() : string {
      let urls = find(this.message, "url");
      return urls.length > 0 ? urls[0].href : '';
  }
  
}
